import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomepageComponent } from './components/core/home/homepage/homepage.component';
import { LoginComponent } from './components/Authentication/login/login.component';
import { ProfileComponent } from './components/core/profile/profile/profile.component';
import { ResigteringComponent } from './components/Authentication/resigtering/resigtering.component';
import { VerificationCodeComponent } from './components/Authentication/verification-code/verification-code.component';
import { authGuard } from './guards/auth.guard';
import { InvoiceComponent } from './components/core/orders/invoice/invoice.component';
import { ForgetPasswordComponent } from './components/Authentication/forget-password/forget-password.component';
import { ChangePasswordComponent } from './components/core/profile/change-password/change-password.component';
import { NodataComponent } from './shared/nodata/nodata.component';
import { ContactUsComponent } from './components/core/static pages/contact-us/contact-us.component';
import { AddorderclientComponent } from './components/core/orders/addorderclient/addorderclient.component';
import { OrdercompletedComponent } from './components/core/orders/ordercompleted/ordercompleted.component';
import { ProductsbypetComponent } from './components/core/home/productsbypet/productsbypet.component';
import { ProductdetailsComponent } from './components/core/home/productdetails/productdetails.component';
import { ProductsbybrandComponent } from './components/core/home/productsbybrand/productsbybrand.component';
import { CartComponent } from './components/core/cart/cart/cart.component';
import { OrdersComponent } from './components/core/orders/orders/orders.component';
import { UseraddressesComponent } from './components/core/profile/addresses/useraddresses/useraddresses.component';
import { UserwalletComponent } from './components/core/profile/wallet/userwallet/userwallet.component';
import { UsernotificationsComponent } from './components/core/profile/notifications/usernotifications/usernotifications.component';
import { AddaddressComponent } from './components/core/profile/addresses/addaddress/addaddress.component';
import { OrderdetailsComponent } from './components/core/orders/orderdetails/orderdetails.component';
import { NointernetComponent } from './components/core/static pages/nointernet/nointernet.component';
import { SearchpageComponent } from './components/core/search/searchpage/searchpage.component';
import { ProductsbycatagoryComponent } from './components/core/home/productsbycatagory/productsbycatagory.component';
import { RefundpolicyComponent } from './components/core/profile/refundpolicy/refundpolicy.component';
import { NoresultComponent } from './components/core/search/noresult/noresult.component';
import { ResultComponent } from './components/core/search/result/result.component';
import { AboutUsComponent } from './components/core/profile/about-us/about-us.component';
import { BundledetailsComponent } from './components/core/home/bundledetails/bundledetails.component';
import { DealsComponent } from './components/core/home/deals/deals.component';
import { ProductmostsalesComponent } from './components/core/home/productmostsales/productmostsales.component';
import { ProducthotdealsComponent } from './components/core/home/producthotdeals/producthotdeals.component';
import { MostratedComponent } from './components/core/home/mostrated/mostrated.component';
import { DailyproductsComponent } from './components/core/home/dailyproducts/dailyproducts.component';
import { ClinicserviceComponent } from './components/core/clinic/clinicservice/clinicservice.component';
import { BookclinicserviceComponent } from './components/core/clinic/bookclinicservice/bookclinicservice.component';
import { MyclinicservicesComponent } from './components/core/clinic/myclinicservices/myclinicservices.component';
import { ClinicservicesComponent } from './components/core/clinic/clinicservices/clinicservices.component';

const routes: Routes = [
  { path: 'verificationCode', component: VerificationCodeComponent },
  { path: 'forget-password', component: ForgetPasswordComponent },
  { path: 'change-password', component: ChangePasswordComponent, canActivate: [authGuard] },
  { path: 'no-data', component: NodataComponent, canActivate: [authGuard] },
  { path: 'Login', component: LoginComponent },
  { path: 'contact-us', component: ContactUsComponent },
  { path: 'about-us', component: AboutUsComponent },

  { path: 'Profile', component: ProfileComponent, canActivate: [authGuard] },
  { path: 'address', component: UseraddressesComponent, canActivate: [authGuard] },
  { path: 'addaddress', component: AddaddressComponent, canActivate: [authGuard] },
  { path: 'wallet', component: UserwalletComponent, canActivate: [authGuard] },
  { path: 'notifications', component: UsernotificationsComponent, canActivate: [authGuard] },
  { path: 'Resigter', component: ResigteringComponent },
  { path: 'Myorders', component: OrdersComponent },
  { path: 'invoice', component: InvoiceComponent },
  { path: 'Addorderclient', component: AddorderclientComponent },
  { path: 'ordercompleted', component: OrdercompletedComponent },
  { path: 'orderdetails', component: OrderdetailsComponent, canActivate: [authGuard] },
  { path: 'cart', component: CartComponent },
  { path: 'category/:name/:id', component: ProductsbycatagoryComponent },
  { path: 'brand/:name/:id', component: ProductsbybrandComponent },
  { path: 'product/:name/:id', component: ProductdetailsComponent },
  { path: 'bundle/:name/:id', component: BundledetailsComponent },
  { path: 'pet/:name/:id', component: ProductsbypetComponent },
  { path: 'refund-policy', component: RefundpolicyComponent },
  { path: 'search-result', component: ResultComponent },
  { path: 'no-result', component: NoresultComponent },
  { path: 'Home', component: HomepageComponent },
  { path: 'deals', component: DealsComponent },
  { path: 'clinic', component: ClinicservicesComponent  },
  { path: 'book/:id', component: BookclinicserviceComponent },
  { path: 'myclinicservices', component: MyclinicservicesComponent },  
  { path: 'clinic-service/:slug/:id', component: ClinicserviceComponent }, 
  { path: 'toprated', component: MostratedComponent },
  { path: 'dailyoffers', component: DailyproductsComponent },
  { path: 'mostsales', component: ProductmostsalesComponent },
  { path: 'topsale', component: ProducthotdealsComponent },
  { path: 'toprated', component: MostratedComponent },

  { path: 'search', component: SearchpageComponent },
  { path: 'no-internet', component: NointernetComponent },
  { path: '', redirectTo: 'Home', pathMatch: 'full' },
  { path: '**', redirectTo: 'Home', pathMatch: 'full' },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
